import styled from "styled-components"
import Column from "../../../../../Column"

const Root = styled(Column)``

export default Root
